"use strict";
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMockCursorProximities = exports.interpolateMockCursorPositions = exports.updateMockUserCursors = exports.initializeOrUpdateMockUsers = exports.prerenderMockCursor = void 0;
var config = __importStar(require("./config.ts"));
var state = __importStar(require("./state.ts"));
var eventHandlers_ts_1 = require("./eventHandlers.ts");
var animationManager_ts_1 = require("./animationManager.ts");
function prerenderMockCursor(user, cellPixelSize) {
    if (cellPixelSize <= 0)
        return;
    if (!user.prerenderedCanvas) {
        user.prerenderedCanvas = document.createElement("canvas");
    }
    var canvas = user.prerenderedCanvas;
    var dpr = state.isMobileLayout ? window.devicePixelRatio || 1 : 1;
    var logicalSize = cellPixelSize;
    canvas.width = logicalSize * dpr;
    canvas.height = logicalSize * dpr;
    var ctx = canvas.getContext("2d");
    if (!ctx)
        return;
    ctx.scale(dpr, dpr);
    // Drawing logic now happens on the off-screen canvas
    ctx.strokeStyle = user.color;
    ctx.lineWidth = 3; // Use logical pixels
    var inset = ctx.lineWidth / 2;
    ctx.strokeRect(inset, inset, logicalSize - inset * 2, logicalSize - inset * 2);
    ctx.fillStyle = user.color;
    var ipFontSize = 10;
    ctx.font = "bold ".concat(ipFontSize, "px Arial");
    ctx.textAlign = "left";
    ctx.textBaseline = "top";
    var textX = 4;
    var textY = 4;
    ctx.fillText(user.id, textX, textY);
    if (user.designation) {
        var designationFontSize = 8;
        textY += ipFontSize + 2;
        ctx.font = "normal ".concat(designationFontSize, "px Arial");
        ctx.fillText(user.designation, textX, textY);
    }
}
exports.prerenderMockCursor = prerenderMockCursor;
function generateFakeIp() {
    var octet = function () { return Math.floor(Math.random() * 256); };
    return "".concat(octet(), ".").concat(octet(), ".").concat(octet(), ".").concat(octet());
}
function initializeOrUpdateMockUsers() {
    var now = performance.now();
    var flowerGridCellPixelSize = config.FLOWER_GRID_CELL_WIDTH_IN_SEGMENTS * state.calculatedSegmentSize;
    while (state.mockUserCursors.length < config.numberOfMockUsers) {
        var initialX = -1000;
        var initialY = -1000;
        var targetCell = null;
        if (flowerGridCellPixelSize > 0 &&
            state.logicalGridCells.numCols > 0 &&
            state.logicalGridCells.numRows > 0) {
            var initialCellCol = Math.floor(Math.random() * state.logicalGridCells.numCols);
            var initialCellRow = Math.floor(Math.random() * state.logicalGridCells.numRows);
            initialX =
                state.logicalGridCells.offsetX +
                    initialCellCol * flowerGridCellPixelSize;
            initialY =
                state.logicalGridCells.offsetY +
                    initialCellRow * flowerGridCellPixelSize;
            targetCell = { x: initialX, y: initialY };
        }
        var newUser = {
            id: generateFakeIp(),
            color: config.MOCK_CURSOR_COLORS[state.mockUserCursors.length % config.MOCK_CURSOR_COLORS.length],
            currentPixelX: initialX,
            currentPixelY: initialY,
            targetCell: targetCell,
            previousCell: targetCell,
            movementStartTime: now,
            lastDecisionTime: now + Math.random() * 2000,
            nextDecisionDelay: 1000 + Math.random() * 2000,
            controlPoint1: null,
            currentMovementDuration: 0,
            isMoving: false,
            designation: "Agent"
        };
        state.mockUserCursors.push(newUser);
        if (flowerGridCellPixelSize > 0) {
            prerenderMockCursor(newUser, flowerGridCellPixelSize);
        }
    }
    // Remove extra cursors if config changes to a smaller number
    if (state.mockUserCursors.length > config.numberOfMockUsers) {
        state.mockUserCursors.length = config.numberOfMockUsers;
    }
    (0, animationManager_ts_1.startAnimation)();
}
exports.initializeOrUpdateMockUsers = initializeOrUpdateMockUsers;
function findNewTargetCell(currentUser, cellPixelSize) {
    if (cellPixelSize <= 0 ||
        !currentUser.targetCell ||
        state.logicalGridCells.numCols <= 0 ||
        state.logicalGridCells.numRows <= 0) {
        return null;
    }
    var currentCellCol = Math.round((currentUser.targetCell.x - state.logicalGridCells.offsetX) / cellPixelSize);
    var currentCellRow = Math.round((currentUser.targetCell.y - state.logicalGridCells.offsetY) / cellPixelSize);
    var possibleMoves = [];
    for (var dx = -1; dx <= 1; dx++) {
        for (var dy = -1; dy <= 1; dy++) {
            if (dx === 0 && dy === 0)
                continue; // No standing still
            var newCol = currentCellCol + dx;
            var newRow = currentCellRow + dy;
            if (newCol >= 0 &&
                newCol < state.logicalGridCells.numCols &&
                newRow >= 0 &&
                newRow < state.logicalGridCells.numRows) {
                possibleMoves.push({ col: newCol, row: newRow });
            }
        }
    }
    if (possibleMoves.length > 0) {
        var move = possibleMoves[Math.floor(Math.random() * possibleMoves.length)];
        return {
            x: state.logicalGridCells.offsetX + move.col * cellPixelSize,
            y: state.logicalGridCells.offsetY + move.row * cellPixelSize
        };
    }
    return null;
}
function updateMockUserCursors(now, cellPixelSize) {
    if (now < state.initialFlowerCreationDelayEndTime)
        return;
    state.mockUserCursors.forEach(function (user) {
        if (!user.isMoving &&
            now > user.lastDecisionTime + user.nextDecisionDelay) {
            user.lastDecisionTime = now;
            user.nextDecisionDelay = 1000 + Math.random() * 2000;
            var newTarget = findNewTargetCell(user, cellPixelSize);
            if (newTarget) {
                user.previousCell = user.targetCell;
                user.targetCell = newTarget;
                user.movementStartTime = now;
                user.isMoving = true;
                user.currentMovementDuration =
                    config.MOCK_CURSOR_MOVEMENT_DURATION_MS_BASE +
                        (Math.random() * 2 - 1) *
                            config.MOCK_CURSOR_MOVEMENT_DURATION_VARIATION_MS;
                if (user.previousCell && user.targetCell) {
                    var midX = (user.previousCell.x + user.targetCell.x) / 2;
                    var midY = (user.previousCell.y + user.targetCell.y) / 2;
                    var perpDx = -(user.targetCell.y - user.previousCell.y);
                    var perpDy = user.targetCell.x - user.previousCell.x;
                    var perpLength = Math.sqrt(perpDx * perpDx + perpDy * perpDy);
                    var normalizedPerpDx = perpLength > 0 ? perpDx / perpLength : 0;
                    var normalizedPerpDy = perpLength > 0 ? perpDy / perpLength : 0;
                    var offset = (Math.random() * 2 - 1) *
                        config.MOCK_CURSOR_MAX_CONTROL_POINT_OFFSET_PIXELS;
                    user.controlPoint1 = {
                        x: midX + offset * normalizedPerpDx,
                        y: midY + offset * normalizedPerpDy
                    };
                }
                else {
                    user.controlPoint1 = null;
                }
            }
        }
    });
}
exports.updateMockUserCursors = updateMockUserCursors;
function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}
function bezier(t, p0, p1, p2) {
    var term0 = (1 - t) * (1 - t) * p0;
    var term1 = 2 * (1 - t) * t * p1;
    var term2 = t * t * p2;
    return term0 + term1 + term2;
}
function interpolateMockCursorPositions(now, _cellPixelSize) {
    state.mockUserCursors.forEach(function (user) {
        var _a;
        if (user.isMoving && user.previousCell && user.targetCell) {
            var elapsed = now - user.movementStartTime;
            var progress = Math.min(1.0, elapsed / user.currentMovementDuration);
            progress = easeInOutCubic(progress);
            if (user.controlPoint1) {
                user.currentPixelX = bezier(progress, user.previousCell.x, user.controlPoint1.x, user.targetCell.x);
                user.currentPixelY = bezier(progress, user.previousCell.y, user.controlPoint1.y, user.targetCell.y);
            }
            else {
                user.currentPixelX =
                    user.previousCell.x +
                        (user.targetCell.x - user.previousCell.x) * progress;
                user.currentPixelY =
                    user.previousCell.y +
                        (user.targetCell.y - user.previousCell.y) * progress;
            }
            if (progress >= 1.0) {
                user.isMoving = false;
                user.previousCell = user.targetCell;
                user.currentPixelX = user.targetCell.x;
                user.currentPixelY = user.targetCell.y;
                user.controlPoint1 = null;
                if (Math.random() < config.MOCK_BOT_FLOWER_CHANCE) {
                    (0, eventHandlers_ts_1.createAndAddFlowerIfInteractive)(user.targetCell, "mock-".concat(user.id), true, (_a = user.currentProximityFactor) !== null && _a !== void 0 ? _a : 0.5);
                }
            }
        }
        if (user.targetCell && !user.isMoving) {
            user.currentPixelX = user.targetCell.x;
            user.currentPixelY = user.targetCell.y;
        }
    });
}
exports.interpolateMockCursorPositions = interpolateMockCursorPositions;
function updateMockCursorProximities() {
    var cellPixelSize = config.FLOWER_GRID_CELL_WIDTH_IN_SEGMENTS * state.calculatedSegmentSize;
    if (cellPixelSize <= 0)
        return;
    var users = state.mockUserCursors;
    for (var i = 0; i < users.length; i++) {
        users[i].currentProximityFactor = 0.5;
    }
    for (var i = 0; i < users.length; i++) {
        for (var j = i + 1; j < users.length; j++) {
            var userA = users[i];
            var userB = users[j];
            if (userA.isMoving ||
                userB.isMoving ||
                !userA.targetCell ||
                !userB.targetCell) {
                continue;
            }
            if (userA.targetCell.x === userB.targetCell.x &&
                userA.targetCell.y === userB.targetCell.y) {
                userA.currentProximityFactor = 1.0;
                userB.currentProximityFactor = 1.0;
                (0, eventHandlers_ts_1.createAndAddFlowerIfInteractive)(userA.targetCell, "overlap-".concat(userA.id, "-").concat(userB.id), true, 1.0, true);
            }
        }
    }
}
exports.updateMockCursorProximities = updateMockCursorProximities;
